(() => {
  const dialog = document.querySelector('[data-varaari-similar-dialog]');
  if (!dialog) return;

  const results = dialog.querySelector('[data-varaari-similar-results]');
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'INR',
  });

  const escapeHtml = (value = '') => {
    const node = document.createElement('div');
    node.textContent = value;
    return node.innerHTML;
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-varaari-similar]');
    if (!trigger) return;

    results.innerHTML = '<p class="varaari-similar-empty">Finding similar pieces...</p>';
    dialog.showModal();

    try {
      const response = await fetch(`/recommendations/products.json?product_id=${trigger.dataset.productId}&limit=4&intent=related`);
      if (!response.ok) throw new Error('Recommendations unavailable');
      const { products = [] } = await response.json();

      results.innerHTML = products.length
        ? products.map((product) => {
            const image = product.featured_image || product.images?.[0];
            const imageMarkup = image
              ? `<img src="${escapeHtml(image)}&width=420" alt="${escapeHtml(product.title)}" loading="lazy">`
              : '';
            return `<a class="varaari-similar-item" href="${escapeHtml(product.url)}">${imageMarkup}<span>${escapeHtml(product.title)}</span><strong>${money.format(product.price / 100)}</strong></a>`;
          }).join('')
        : '<p class="varaari-similar-empty">More similar pieces will appear as the Varaari collection grows.</p>';
    } catch (error) {
      results.innerHTML = '<p class="varaari-similar-empty">Similar pieces are not available right now.</p>';
    }
  });

  dialog.querySelector('[data-varaari-dialog-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
})();

